<script>
export default {
  render() {
    return (
      this.$slots.default && (
        <ul class={this.$style.root}>
          {this.$slots.default.map(vnode => (
            <li class={this.$style.item}>{vnode}</li>
          ))}
        </ul>
      )
    )
  }
}
</script>

<style lang="scss" module>
.root {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.item {
  & ~ & {
    margin-top: 1em;
  }
}
</style>
